module.exports = __webpack_public_path__ + "img/emoji-happiest-on.7a6c29d2.svg";